import React from "react";
import {UserListView} from "./UserListView";
import {ContentViewContainer} from "../ContentView";
import {AppContainer} from "../common/AppContainer";
import {useAppSelector} from "../../hooks/ReduxHooks";
import {StackPanel} from "../panels/StackPanel";
import {isUserDtoContent} from "../../domain/ItemContent";
import {getItemContent} from "../../state/ItemState";

export const UserManagementView = () => {
    const hasContent = useAppSelector(({itemState}) => isUserDtoContent(getItemContent(itemState)));

    return (
        <AppContainer>
            <ContentViewContainer hasContent={hasContent}
                                  itemsListElement={<StackPanel orientation="vertical"
                                                                align="stretch"
                                                                fill={true}
                                                                className="left-panel content-item-list">
                                      <UserListView/>
                                  </StackPanel>}
            />
        </AppContainer>
    );
};
